import React, { useState, useEffect } from "react";
import {
  fetchclub,
  changeClubStatus,
  changeGratuityFeature,
} from "../../services/clubService";
import { Icon } from "@iconify/react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import SuccessAlert from "../../components/child/Alert/SuccessAlert";
import DengerAlert from "../../components/child/Alert/DengerAlert";
import { showConfirmationDialog } from "../../utils/apiHelper";

const ClubListLayer = ({ userId }) => {
  const [items, setItems] = useState([]);
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
    const [isFeatureFilter, setisFeatureFilter] = useState("");
     const [isGratuityFilter, setisGratuityFilter] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  // ✅ initialize from URL
  const [typeFilter, setTypeFilter] = useState(searchParams.get("type") || ""); // ✅ Correct type filter

  const navigate = useNavigate();

  // useEffect(() => {
  //   let typeFromUrl = searchParams.get("type");
  //   if (typeFromUrl && typeFromUrl !== "") {
  //     typeFromUrl =
  //       typeFromUrl.charAt(0).toUpperCase() +
  //       typeFromUrl.slice(1).toLowerCase();

  //     setTypeFilter(typeFromUrl);
  //   } else {
  //     setTypeFilter(""); // 👈 default when type is empty
  //   }
  // }, [searchParams]);
   useEffect(() => {
    const urlType = searchParams.get("type") || "";
    setTypeFilter(urlType);
  }, [searchParams]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await fetchclub({
        page: currentPage,
        limit: itemsPerPage,
        search: searchQuery,
        sortBy: sortColumn,
        sortOrder: sortOrder,
        status: statusFilter,
        type: typeFilter, // ✅ pass correct type filter
        isGratuity:isGratuityFilter,
        userId: userId,
      });
      console.log("Fetched Data:", res.data);
      setItems(res.data.data);
      setTotalItems(res.data.pagination.total);
      setTotalPages(res.data.pagination.totalPages);
    } catch (error) {
      setErrorMessage("Failed to fetch club");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    searchQuery,
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
    statusFilter,
    typeFilter,
    isGratuityFilter,
    userId,
  ]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  const handleTypeChange = (value) => {
    setTypeFilter(value);
    setCurrentPage(1);

    // update URL param
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set("type", value);
    } else {
      newParams.delete("type");
    }
    setSearchParams(newParams);
  };

  const handleStatusClick = async (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const message = `This action will change the status to ${newStatus}.`;
    const confirmMessage = "Yes, change it!";

    const result = await showConfirmationDialog(message, confirmMessage);
    if (!result.isConfirmed) return;

    try {
      const response = await changeClubStatus(id, { status: newStatus });

      const successText =
        response?.data?.message ||
        response?.message ||
        "Status updated successfully";

      setSuccessMessage(successText);
      fetchData();

      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      const errorText =
        err?.response?.data?.message || err?.message || "Error updating status";
      setErrorMessage(errorText);
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const handleGratuityClick = async (id, currentStatus) => {
    const newStatus = currentStatus === true ? false : true;

    // Convert to Yes/No for dialog message
    const statusText = newStatus ? "Yes" : "No";

    const message = `This action will change the gratuity to ${statusText}.`;

    const confirmMessage = "Yes, change it!";

    const result = await showConfirmationDialog(message, confirmMessage);
    if (!result.isConfirmed) return;

    try {
      const response = await changeGratuityFeature(id, { isGratuity: newStatus });

      const successText =
        response?.data?.message ||
        response?.message ||
        "Gratuity updated successfully";

      setSuccessMessage(successText);
      fetchData();

      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      const errorText =
        err?.response?.data?.message || err?.message || "Error updating status";
      setErrorMessage(errorText);
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const getPaginationRange = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const maxVisiblePages = 5;
    const pages = [];
    
    if (totalPages <= maxVisiblePages) {
      // If total pages is 5 or less, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Calculate the start page for the visible range
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      
      // Adjust start page if we're near the end
      if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
      
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}

      {/* Header and Filters */}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className="text-md fw-medium text-secondary-light mb-0">
            Show
          </span>

          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value="10">10 items per page</option>
            <option value="20">20 items per page</option>
            <option value="50">50 items per page</option>
            <option value="100">100 items per page</option>
          </select>

          <form className="navbar-search" style={{ position: "relative" }}>
            <input
              type="text"
              className="bg-base h-40-px w-auto pe-40"
              name="search"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={(e) => {
                if (e.target.value === "") {
                  setCurrentPage(1);
                }
              }}
              style={{
                paddingRight: searchQuery ? "5rem" : "2.5rem",
              }}
            />
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{
                position: "absolute",
                right: searchQuery ? "3.25rem" : "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "1.25rem",
                color: "#999",
                pointerEvents: "none",
              }}
            />
            {searchQuery && (
              <button
                type="button"
                onClick={() => {
                  setSearchQuery("");
                  setCurrentPage(1);
                }}
                style={{
                  position: "absolute",
                  right: "1rem",
                  top: "30%",
                  transform: "translateY(-50%)",
                  fontSize: "1.25rem",
                  color: "#000",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Icon icon="ic:round-close" />
              </button>
            )}
          </form>

          {/* Status Filter */}
          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
           <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={isGratuityFilter}
            onChange={(e) => {
              setisGratuityFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Gratuity</option>
            <option value="true">Yes</option>
            <option value="false">NO</option>
          </select>

          {/* ✅ Type Filter */}
          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={typeFilter}
            onChange={(e) => handleTypeChange(e.target.value)}
          >
            <option value="">All Type</option>
            <option value="VIP Entry">VIP Entry</option>
            <option value="Club">Club</option>
            <option value="Booth">Booth</option> 
            <option value="Event">Event</option>
            <option value="Table">Table</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("name")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    Name
                    <span className="sort-colume">
                      <Icon
                        icon="mdi:arrow-up"
                        className={`arrow ${
                          sortColumn === "name" && sortOrder === "asc"
                            ? "active"
                            : ""
                        }`}
                      />
                      <Icon
                        icon="mdi:arrow-down"
                        className={`arrow ${
                          sortColumn === "name" && sortOrder === "desc"
                            ? "active"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                </th>
                <th
                  onClick={() => handleSort("type")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    Type
                    <span className="sort-colume">
                      <Icon
                        icon="mdi:arrow-up"
                        className={`arrow ${
                          sortColumn === "type" && sortOrder === "asc"
                            ? "active"
                            : ""
                        }`}
                      />
                      <Icon
                        icon="mdi:arrow-down"
                        className={`arrow ${
                          sortColumn === "type" && sortOrder === "desc"
                            ? "active"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                </th>
                {/* <th
                  onClick={() => handleSort("entryFee")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    Entry Fee($)
                    <span className="sort-colume">
                      <Icon
                        icon="mdi:arrow-up"
                        className={`arrow ${
                          sortColumn === "entryFee" && sortOrder === "asc"
                            ? "active"
                            : ""
                        }`}
                      />
                      <Icon
                        icon="mdi:arrow-down"
                        className={`arrow ${
                          sortColumn === "entryFee" && sortOrder === "desc"
                            ? "active"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                </th> */}
                <th
                  onClick={() => handleSort("fullname")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    Host By
                    <span className="sort-colume">
                      <Icon
                        icon="mdi:arrow-up"
                        className={`arrow ${
                          sortColumn === "fullname" && sortOrder === "asc"
                            ? "active"
                            : ""
                        }`}
                      />
                      <Icon
                        icon="mdi:arrow-down"
                        className={`arrow ${
                          sortColumn === "fullname" && sortOrder === "desc"
                            ? "active"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                </th>
                <th
                  onClick={() => handleSort("createdAt")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    Created Date
                    <span className="sort-colume">
                      <Icon
                        icon="mdi:arrow-up"
                        className={`arrow ${
                          sortColumn === "createdAt" && sortOrder === "asc"
                            ? "active"
                            : ""
                        }`}
                      />
                      <Icon
                        icon="mdi:arrow-down"
                        className={`arrow ${
                          sortColumn === "createdAt" && sortOrder === "desc"
                            ? "active"
                            : ""
                        }`}
                      />
                    </span>
                  </div>
                </th>
                <th>Gratuity</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    <span className="loader-15"></span>
                  </td>
                </tr>
              ) : items.length > 0 ? (
                items.map((cl) => (
                  <tr key={cl._id}>
                    <td>{cl.name}</td>
                    <td>{cl.type}</td>
                    {/* <td>{cl.entryFee}</td> */}
                    <td>{cl.user.fullName}</td>
                    <td>
                      {(() => {
                        const date = new Date(cl.createdAt);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = date.getMonth() + 1;
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </td>
                    <td>
                      <span
                        onClick={() =>
                          handleGratuityClick(cl._id, cl.isGratuity)
                        }
                        className={`${
                          cl.isGratuity === true || cl.isGratuity === "true"
                            ? "bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                            : "bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                        }`}
                        style={{ cursor: "pointer" }}
                        title={
                          cl.isGratuity === true || cl.isGratuity === "true"
                            ? "Click to set No"
                            : "Click to set Yes"
                        }
                      >
                        {cl.isGratuity === true || cl.isGratuity === "true"
                          ? "Yes"
                          : "No"}
                      </span>
                    </td>
                    <td>
                      <span
                        onClick={() => handleStatusClick(cl._id, cl.status)}
                        className={`${
                          cl.status === "active"
                            ? "bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                            : "bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                        }`}
                        style={{ cursor: "pointer" }}
                        title={
                          cl.status === "active"
                            ? "Click to Deactivate"
                            : "Click to Activate"
                        }
                      >
                        {cl.status.charAt(0).toUpperCase() + cl.status.slice(1)}
                      </span>
                    </td>

                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {userId ? (
                          <button
                            type="button"
                            onClick={() =>
                              navigate(
                                `/host/view-userclub/${cl._id}/${userId}`
                              )
                            }
                            title="View"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() =>
                              navigate(`/club/view-club/${cl._id}`)
                            }
                            title="View"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            {totalItems === 0 ? (
              <>No entry to show</>
            ) : (
              <>
                Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
                {totalItems} entries
              </>
            )}
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                onClick={() => {
                  if (currentPage > 1) setCurrentPage((prev) => prev - 1);
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </button>
            </li>

            {getPaginationRange().map((pageNum) => (
              <li key={pageNum} className="page-item">
                <button
                  className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${
                    currentPage === pageNum
                      ? "bg-primary-600 text-white"
                      : "bg-neutral-200"
                  }`}
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}

            <li className="page-item">
              <button
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                disabled={currentPage === totalPages}
                onClick={() => {
                  if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ClubListLayer;
